import { v } from "convex/values";
import { literalValues } from "@shared/validation/literal-values";

export function literalUnion<const Shape extends Record<string, string>>(shape: Shape) {
  const [first, ...rest] = literalValues(shape);
  return v.union(v.literal(first), ...rest.map((value) => v.literal(value)));
}
